
<!-- Fornecedor do pedido: escolhido aqui quando a compra chega sem cotação; gravado no "Salvar". -->
<div class="section-title">
  <mat-icon>storefront</mat-icon>
  <span>Fornecedor do pedido</span>
</div>
<div class="ced-ped-fornecedor">
  <app-select-pesquisavel
    [control]="fornecedorControl"
    [apiUrl]="urlFornecedor"
    [preloadedOptions]="fornecedorOpcaoAtual"
    [disabled]="fornecedorBloqueado"
    label="Fornecedor"
    idField="id"
    nameField="descricao"
    subscriptSizing="dynamic"
    (selectionChange)="onFornecedorSelecionado($event)">
  </app-select-pesquisavel>
  @if (fornecedorBloqueado) {
    <div class="ced-ped-fornecedor__hint">
      <mat-icon class="material-symbols-outlined">lock</mat-icon>
      Pedido já enviado ao fornecedor: a troca não é mais permitida.
    </div>
  }
</div>

<!-- Produtos -->
<div class="section-title">
  <mat-icon>list_alt</mat-icon>
  <span>Produtos</span>
  <span class="status-badge badge-cinza">{{ pedidoItens.length }}</span>
  <div class="section-title-actions ms-auto">
    @if (!itemAdding) {
      <button mat-button type="button" class="btn-section" (click)="toggleAddingItem()">
        <mat-icon>add</mat-icon>
        Adicionar item
      </button>
    } @else {
      <button mat-button type="button" class="btn-section btn-section--cancel" (click)="toggleAddingItem()">
        <mat-icon>close</mat-icon>
        Cancelar
      </button>
    }
  </div>
</div>

<!-- Itens mudaram depois do envio: o fornecedor ainda tem a versão antiga. -->
@if (isAlteradoAposEnvio) {
  <app-alert-card type="warning" icon="warning" title="Pedido alterado após o envio.">
    Reenvie o pedido ao fornecedor para que ele receba a versão atual.
  </app-alert-card>
}

<!-- Mesmo painel do "Adicionar fornecedor" da Solicitação/Cotação. -->
@if (itemAdding) {
  <div class="ced-cot-add">
    <div class="ced-cot-add__head">
      <mat-icon class="material-symbols-outlined">add_shopping_cart</mat-icon>
      <span>Adicionar item ao pedido</span>
      <span class="ced-section-spacer"></span>
      <button type="button" class="ced-cot-add__close" (click)="toggleAddingItem()" matTooltip="Fechar">
        <mat-icon class="material-symbols-outlined">close</mat-icon>
      </button>
    </div>
    <div class="ced-cot-add__body">
      <app-ced-busca-produto [itensAdicionados]="pedidoItens" (produtoSelecionado)="addProductFromSearch($event)"></app-ced-busca-produto>
      <div class="ced-cot-add__hint">
        <mat-icon class="material-symbols-outlined">info</mat-icon>
        Só produtos do cadastro: o Pedido não aceita item avulso. Quantidade, preço e tributos são ajustados no item.
      </div>
    </div>
  </div>
}

@for (it of pedidoItens; track it.idCompraItem ?? $index; let i = $index) {
  <div class="ced-ped-item">
    <div class="ced-ped-item__head">
      <span class="ced-product-icon">
        <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
      </span>
      <div class="ced-ped-item__info">
        <div class="ced-product-name">{{ it.name }}</div>
        <div class="ced-ped-item__meta">
          @if (it.sku) { <span class="ced-mono">{{ it.sku }}</span> · }
          <span [class.ced-warn]="pedidoIsLowStock(it)">
            @if (pedidoIsLowStock(it)) {
              <mat-icon class="material-symbols-outlined">warning</mat-icon>
            }
            estoque {{ it.stock != null ? it.stock : '—' }}
          </span>
        </div>
      </div>
      <div class="ced-ped-item__qty">
        <span class="ced-mini-label">Qtd.</span>
        <span class="ced-ped-qty-edit">
          <input class="ced-ped-qty-input"
            [currencyMask]="quantidadeMask"
            [ngModel]="it.qty"
            (ngModelChange)="onQuantidadeChange(it, $event)"
            [attr.aria-label]="'Quantidade de ' + it.name">
          <small>{{ it.unit }}</small>
        </span>
      </div>
      <button type="button" mat-icon-button class="btn-remover" (click)="removeItem(i)" matTooltip="Remover item">
        <mat-icon class="material-symbols-outlined">delete</mat-icon>
      </button>
    </div>

    <div class="ced-ped-item__grid">
      <mat-form-field appearance="outline" class="ced-form-field" subscriptSizing="dynamic">
        <mat-label>Preço unit.</mat-label>
        <input matInput [currencyMask]="moedaMask" [(ngModel)]="it.preco" (ngModelChange)="onTotalPedidoChange()">
      </mat-form-field>
      <mat-form-field appearance="outline" class="ced-form-field" subscriptSizing="dynamic">
        <mat-label>IPI</mat-label>
        <input matInput [currencyMask]="moedaMask" [(ngModel)]="it.ipi" (ngModelChange)="onTotalPedidoChange()">
      </mat-form-field>
      <mat-form-field appearance="outline" class="ced-form-field" subscriptSizing="dynamic">
        <mat-label>ST</mat-label>
        <input matInput [currencyMask]="moedaMask" [(ngModel)]="it.st" (ngModelChange)="onTotalPedidoChange()">
      </mat-form-field>
      <mat-form-field appearance="outline" class="ced-form-field" subscriptSizing="dynamic">
        <mat-label>IBS</mat-label>
        <input matInput [currencyMask]="moedaMask" [(ngModel)]="it.ibs" (ngModelChange)="onTotalPedidoChange()">
      </mat-form-field>
      <mat-form-field appearance="outline" class="ced-form-field" subscriptSizing="dynamic">
        <mat-label>CBS</mat-label>
        <input matInput [currencyMask]="moedaMask" [(ngModel)]="it.cbs" (ngModelChange)="onTotalPedidoChange()">
      </mat-form-field>
      <mat-form-field appearance="outline" class="ced-form-field" subscriptSizing="dynamic">
        <mat-label>Desconto</mat-label>
        <input matInput [currencyMask]="moedaMask" [(ngModel)]="it.desconto" (ngModelChange)="onTotalPedidoChange()">
      </mat-form-field>
    </div>

    <div class="ced-ped-item__foot">
      <span>Subtotal estimado</span>
      <span class="ced-ped-subtotal">R$ {{ cotFmt(pedidoSubtotal(it)) }}</span>
    </div>
  </div>
} @empty {
  <p class="ced-empty-text">Nenhum item no pedido.</p>
}

<!-- Condições comerciais -->
<div class="section-title">
  <mat-icon>payments</mat-icon>
  <span>Condições comerciais</span>
</div>
<div class="ced-field-grid">
  <mat-form-field appearance="outline" class="ced-form-field">
    <mat-label>Forma de pagamento</mat-label>
    <mat-select [(ngModel)]="pedidoFormaPagamento" (ngModelChange)="dirty.emit()" required>
      @for (opt of pedidoFormaPagamentoOpcoes; track opt) {
        <mat-option [value]="opt">{{ opt }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
   <mat-form-field appearance="outline" class="ced-form-field">
     <mat-label>Prazo de entrega (dias)</mat-label>
     <input matInput [currencyMask]="diasMask" [ngModel]="pedidoPrazoEntregaDias"
       (ngModelChange)="onPrazoEntregaChange($event)" inputmode="numeric" required
       placeholder="Ex.: 12">
   </mat-form-field>
  </div>
  <div class="ced-field">
    <mat-form-field appearance="outline" class="ced-form-field">
      <mat-label>Observação sobre o prazo de entrega</mat-label>
      <textarea matInput rows="2" [(ngModel)]="pedidoObservacoes" (ngModelChange)="dirty.emit()"
        placeholder="Ex.: entrega parcial ou condição combinada com o fornecedor"></textarea>
    </mat-form-field>
  </div>

<!-- Parcelas -->
<div class="ced-ped-parcelas">
  <div class="ced-ped-parcelas__head">
    <span class="ced-mini-label">Parcelas{{ pedidoParcelas.length ? (parcelasAutomaticas ? ' · valores automáticos' : ' · valores manuais') : '' }}</span>
    <div class="ced-ped-parcelas__actions">
      @if (pedidoParcelas.length && !parcelasAutomaticas) {
        <button type="button" class="ced-add-link" (click)="distribuirValoresParcelas()">
          <mat-icon class="material-symbols-outlined">calculate</mat-icon>
          Distribuir valores
        </button>
      }
      <button type="button" class="ced-add-link" (click)="addParcela()">
        <mat-icon class="material-symbols-outlined">add</mat-icon>
        Adicionar parcela
      </button>
    </div>
  </div>
  @for (parcela of pedidoParcelas; track $index) {
    <div class="ced-ped-parcela-row">
      <span class="ced-ped-parcela-row__seq">{{ parcela.sequencia }}ª</span>
      <mat-form-field appearance="outline" class="ced-form-field" subscriptSizing="dynamic">
        <mat-label>Dias</mat-label>
        <input matInput [currencyMask]="diasMask" [(ngModel)]="parcela.dias" (ngModelChange)="dirty.emit()">
      </mat-form-field>
      <mat-form-field appearance="outline" class="ced-form-field" subscriptSizing="dynamic">
        <mat-label>Valor</mat-label>
        <input matInput [currencyMask]="moedaMask" [(ngModel)]="parcela.valor" (ngModelChange)="onValorParcelaChange()">
      </mat-form-field>
      <button type="button" mat-icon-button class="btn-remover" (click)="removeParcela($index)" matTooltip="Remover parcela">
        <mat-icon class="material-symbols-outlined">delete</mat-icon>
      </button>
    </div>
  } @empty {
    <div class="ced-ped-parcelas__empty">Sem parcelas. À vista, ou adicione o parcelamento.</div>
  }
</div>

<!-- Valores do pedido -->
<div class="section-title">
  <mat-icon>receipt_long</mat-icon>
  <span>Valores do pedido</span>
</div>
<div class="ced-ped-hint">Aplicados ao pedido como um todo (não por item).</div>
<div class="ced-field-grid">
  <mat-form-field appearance="outline" class="ced-form-field">
    <mat-label>Frete</mat-label>
    <input matInput [currencyMask]="moedaMask" [(ngModel)]="pedidoFrete" (ngModelChange)="onTotalPedidoChange()">
  </mat-form-field>
  <mat-form-field appearance="outline" class="ced-form-field">
    <mat-label>Outras despesas</mat-label>
    <input matInput [currencyMask]="moedaMask" [(ngModel)]="pedidoOutrasDespesas" (ngModelChange)="onTotalPedidoChange()">
  </mat-form-field>
</div>

<!-- Contabilidade -->
<div class="section-title">
  <mat-icon>account_balance</mat-icon>
  <span>Contabilidade</span>
</div>
<div class="ced-field-grid">
  <mat-form-field appearance="outline" class="ced-form-field">
    <mat-label>Centro de custo</mat-label>
    <mat-select [(ngModel)]="pedidoCentroCusto" (ngModelChange)="dirty.emit()">
      <mat-option [value]="null">—</mat-option>
      @for (opt of pedidoCentroCustoOpcoes; track opt.id) {
        <mat-option [value]="opt.id">{{ opt.codigo ? opt.codigo + ' · ' : '' }}{{ opt.descricao }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline" class="ced-form-field">
    <mat-label>Categoria do DRE</mat-label>
    <mat-select [(ngModel)]="pedidoCategoriaDre" (ngModelChange)="dirty.emit()">
      <mat-option [value]="null">—</mat-option>
      @for (opt of pedidoCategoriaDreOpcoes; track opt.id) {
        <mat-option [value]="opt.id">{{ opt.codigo ? opt.codigo + ' · ' : '' }}{{ opt.descricao }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>

<!-- Envio ao fornecedor: só mostra o botão quando a Aprovação está desativada. -->
<app-ced-envio-pedido
  [envio]="state.envio"
  [mostrarBotao]="!aprovacaoAtiva"
  (enviarPedido)="enviarPedido.emit($event)">
</app-ced-envio-pedido>
